//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import Facebook from '../../icons/footerFacebook.svg';
import LinkedIn from '../../icons/footerLinkedIn.svg';
import Twitter from '../../icons/footertwitter.svg';
import Insta from '../../icons/footerInsta.svg';
import YT from '../../icons/footerYT.svg';
import { commonStyles } from '../../styles/commonStyles';
import settings from '../../Config/settings';
import { useConfig } from '../../Config';

type Provider = keyof typeof settings.links;

function getFooterLinks(provider: Provider) {
  const providerLinks = settings.links[provider];
  return providerLinks?.footer || {};
}

const Footer: React.FC = () => {
  const { services } = useConfig();
  const provider = (services?.provider?.name || 'HCL') as Provider;
  const footerLinks = getFooterLinks(provider);

  return (
    <footer id="footer" style={commonStyles.footerStyle}>
      <a href={footerLinks.Facebook} target="_blank" rel="noopener noreferrer">
        <img
          src={Facebook}
          alt="Facebook Icon"
          style={{ height: '18px', cursor: 'pointer' }}
        />
      </a>
      <a href={footerLinks.LinkedIn} target="_blank" rel="noopener noreferrer">
        <img
          src={LinkedIn}
          alt="LinkedIn Icon"
          style={{ height: '18px', marginLeft: '22px', cursor: 'pointer' }}
        />
      </a>
      <a href={footerLinks.Twitter} target="_blank" rel="noopener noreferrer">
        <img
          src={Twitter}
          alt="Twitter Icon"
          style={{ height: '18px', marginLeft: '22px', cursor: 'pointer' }}
        />
      </a>
      <a href={footerLinks.Instagram} target="_blank" rel="noopener noreferrer">
        <img
          src={Insta}
          alt="Instagram Icon"
          style={{ height: '18px', marginLeft: '22px', cursor: 'pointer' }}
        />
      </a>
      <a href={footerLinks.YouTube} target="_blank" rel="noopener noreferrer">
        <img
          src={YT}
          alt="YouTube Icon"
          style={{ height: '18px', marginLeft: '22px', cursor: 'pointer' }}
        />
      </a>
    </footer>
  );
};

export default Footer;
